import { render, staticRenderFns } from "./footerView.vue?vue&type=template&id=0aea9406&scoped=true"
import script from "./footerView.vue?vue&type=script&lang=js"
export * from "./footerView.vue?vue&type=script&lang=js"
import style0 from "./footerView.vue?vue&type=style&index=0&id=0aea9406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea9406",
  null
  
)

export default component.exports